import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import { Input } from './index.js';
const CustomInput = (props) => {
    return (React.createElement(Input, { value: (props.selected && props.selected.calendar()) || '', ...props }));
};
const DateInput = (props) => {
    const showClear = props.allowNull && props.value && !props.disabled;
    return (React.createElement(Wrapper, null,
        React.createElement(StyledDatePicker, { customInput: React.createElement(CustomInput, { success: !!props.value, style: props.style, disabled: props.disabled }), placeholderText: props.placeholder, dateFormat: props.customDateFormat
                ? props.customDateFormat
                : [
                    `dd.MM.yyyy${props.showTimeSelect ? ' HH:mm' : ''}`,
                    `dd.MM.yy${props.showTimeSelect ? ' HH:mm' : ''}`,
                    `dd/MM/yy${props.showTimeSelect ? ' HH:mm' : ''}`,
                    `dd-MM-yy${props.showTimeSelect ? ' HH:mm' : ''}`,
                    `ddMMyy${props.showTimeSelect ? ' HH:mm' : ''}`,
                    `dd/MM/yyyy${props.showTimeSelect ? ' HH:mm' : ''}`,
                    `dd-MM-yyyy${props.showTimeSelect ? ' HH:mm' : ''}`,
                    `ddMMyyyy${props.showTimeSelect ? ' HH:mm' : ''}`,
                ], selected: props.value && props.value.toDate(), onChange: (date) => {
                if (props.onChange) {
                    if (props.allowNull) {
                        props.onChange(date != null ? moment(date) : null);
                    }
                    else if (date != null) {
                        props.onChange(moment(date));
                    }
                }
            }, maxDate: props.maxDate, minDate: props.minDate, filterDate: props.filterDate, showTimeSelect: props.showTimeSelect, timeFormat: props.showTimeSelect ? 'HH:mm' : undefined, timeIntervals: props.showTimeSelect ? 1 : undefined, strictParsing: true, disabled: props.disabled, popperProps: { strategy: 'fixed' } }),
        showClear && (React.createElement(ClearButton, { onClick: (e) => {
                e.stopPropagation();
                if (props.allowNull && props.onChange) {
                    props.onChange(null);
                }
            } }, "\u00D7"))));
};
export default DateInput;
const Wrapper = styled.div `
  position: relative;

  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    display: block;
  }
`;
// @ts-expect-error
const StyledDatePicker = styled(DatePicker) ``;
const ClearButton = styled.button `
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: ${THEME.COLOR_GREY};
  padding: 0;
  line-height: 1;

  &:hover {
    color: ${THEME.COLOR_PRIMARY};
  }
`;
//# sourceMappingURL=DateInput.js.map